<!--Menu nuevo-->
<!-- <div *ngIf="db != 'Produccion'" style="width: 100%; background-color: red; text-align: center;">
    <h4>Pagina de: {{db}}</h4>
</div> -->
<nav class="nav-i">
    <input type="checkbox" id="check">
    <label for="check" class="checkbtn">
        <i class="fas fa-bars"></i>
    </label>
    <label class="logo"><a routerLink="/inicio"><img class="img-log"
                src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo_Triidy_3.0.svg" alt=""></a></label>
    <ul>
        <!--<li><a routerLink="/inicio">Home</a></li>-->
        <li><a class="s-men" routerLink="/nosotros" routerLinkActive="active">Nosotros</a></li>
        <li><a class="s-men" routerLink="/servicios" routerLinkActive="active">Servicios</a></li>
        <!--<li><a class="s-men" routerLink="/aprende" routerLinkActive="active">Aprende</a></li>-->
        <li><a class="s-men" routerLink="/pedidos/rastreo" routerLinkActive="active">Rastreo</a></li>
        <li><a class="sesion2" routerLink="/login" routerLinkActive="active">Iniciar Sesion</a></li>
        <li><a class="sesion s-men" routerLink="/registro-comercio" routerLinkActive="active">Registro Tienda</a></li>
        <!--<li><a class="sesion s-men dropdown-toggle" d="dropdownMenuLink" data-toggle="dropdown">Registrate</a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <a class="dropdown-item s-men" routerLink="/registro-comercio">Comercios</a>
                <a class="dropdown-item s-men" routerLink="/registro-mensajero">Mensajeros</a>
            </div>
        </li>-->
        <!--<li class="nav-i"><a routerLink="/login2"><i class="fas fa-mobile-alt fa-2x"></i></a></li>-->
        <li class="nav-i"><a href="https://triidy.info/default.aspx" target="_blank"><i
                    class="fas fa-mobile-alt fa-2x"></i></a></li>
    </ul>
</nav>

<nav class="mov-i" role="navigation">
    <label class="logo"><a routerLink="/inicio"><img class="img-log"
                src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo_Triidy_3.0.svg" alt=""></a></label>
    <div id="menuToggle" #sidenav>
        <input type="checkbox" id="checkMenu" />
        <span></span>
        <span></span>
        <span></span>
        <ul id="menu">
            <li><a class="s-men" routerLink="/nosotros" routerLinkActive="active">Nosotros</a></li>
            <li><a class="s-men" routerLink="/servicios" routerLinkActive="active">Servicios</a></li>
            <!--<li><a class="s-men" routerLink="/aprende" routerLinkActive="active">Aprende</a></li>-->
            <li><a class="s-men" routerLink="/pedidos/rastreo" routerLinkActive="active">Rastreo</a></li>
            <li><a class="s-men" routerLink="/login" routerLinkActive="active">Iniciar Sesion</a></li>
            <li><a class="s-men" routerLink="/registro-comercio" routerLinkActive="active">Registro Tienda</a>
            </li>
            <!--<li><a class="sesion s-men dropdown-toggle" d="dropdownMenuLink" data-toggle="dropdown">Registrate</a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item s-men" routerLink="/registro-comercio">Comercios</a>
                    <a class="dropdown-item s-men" routerLink="/registro-mensajero">Mensajeros</a>
                </div>
            </li>-->
            <li class="mov-i"><a href="https://triidy.info/default.aspx" target="_blank"><i
                        class="fas fa-mobile-alt fa-2x"></i></a></li>
            <!--<li class="mov-i"><a href="market://search?q=triidy"><i class="fas fa-mobile-alt fa-2x"></i></a></li>-->
        </ul>
    </div>
</nav>